export const ViewCar = () => {
  return <></>;
};
